// AI Studio: the clip editor with only the preview and the assistant chat, at
// /project/<id>/ai-studio and /library/<id>/ai-studio (same ?clip= as /edit).

const STUDIO_PATH = /^\/(project|library)\/[A-Za-z0-9_-]+\/ai-studio\/?$/;

export function isAiStudioPath(path: string): boolean {
  return STUDIO_PATH.test(path.split(/[?#]/, 1)[0]);
}

export function aiStudioPathFor({ kind, id, clipId }: {
  kind: 'project' | 'library';
  id: string;
  clipId?: string | null;
}): string {
  const base = `/${kind}/${id}/ai-studio`;
  return clipId ? `${base}?clip=${encodeURIComponent(clipId)}` : base;
}

/** The full editor for a studio URL, keeping its query (the clip). */
export function editorPathFromStudio(pathWithSearch: string): string {
  return pathWithSearch.replace(/\/ai-studio\/?(?=$|[?#])/, '/edit');
}
